import { createFileRoute } from '@tanstack/react-router'
import { DataQualityPage } from '../../../components/data/DataQualityPage'

export const Route = createFileRoute('/$org/data/quality')({
  component: DataQuality,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      // The in-category facet: completeness | consistency | document_hygiene.
      subcategory: search.subcategory ? String(search.subcategory) : undefined,
      selected: search.selected ? String(search.selected) : undefined,
      status: search.status ? String(search.status) : undefined,
      sort: search.sort ? String(search.sort) : undefined,
      q: search.q ? String(search.q) : undefined,
      // A number, not a string: the router round-trips a numeric search value
      // as `page=2`, but quotes a string one as `page="2"`.
      page: search.page !== undefined ? Number(search.page) || undefined : undefined,
      // Sub-tickets as rows, and the due follow-ups (spec 2026-10-27-19 § 6).
      // Optional keys (spread), so links to this page need not name them.
      ...(search.children !== undefined && Number(search.children) === 1 ? { children: 1 as const } : {}),
      ...(search.follow_up === 'due' ? { follow_up: 'due' as const } : {}),
    }
  },
})

function DataQuality() {
  return <DataQualityPage />
}
